import { Dispatch } from "redux"
import { toast } from "react-toastify"
import { RevenueVsBudgetRow, IConsultingRevenueVsBudgetQuery } from "models/consulting-revenue-budget"
import { buildQueryString } from "utils/query-string"
import { formatCurrency } from "utils/tools"
import FiscalCalendar, { DEFAULT_FISCAL_START } from "utils/fiscal-calendar"
import { setData } from "./reducer"

export const downloadConsultingRevenueVsBudgetCSV = (
    byDivision: RevenueVsBudgetRow[],
    byBranch: RevenueVsBudgetRow[],
    byDepartment: RevenueVsBudgetRow[],
    query: IConsultingRevenueVsBudgetQuery
) => {
    const calendar = new FiscalCalendar(DEFAULT_FISCAL_START)
    const toLabel = (code: number) => calendar.fiscalToLabel(Math.floor(code / 100), code % 100)
    const metadata = `From: ${toLabel(query.fromPeriod ?? calendar.todayFiscalPeriod())} | To: ${toLabel(query.toPeriod ?? calendar.todayFiscalPeriod())}`

    const headers = ["Name", "Revenue", "Budget", "Variance"]
    const toRow = (row: RevenueVsBudgetRow) => [row.name, formatCurrency(row.actual), formatCurrency(row.budget), formatCurrency(row.variance)]

    const csv = [
        [metadata], [],
        ["By Division"], headers, ...byDivision.map(toRow), [],
        ["By Branch"], headers, ...byBranch.map(toRow), [],
        ["By Department"], headers, ...byDepartment.map(toRow),
    ]
        .map(r => r.map(v => `"${String(v).replace(/"/g, '""')}"`).join(","))
        .join("\n")

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" })
    const url = URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = `consulting-revenue-vs-budget-${query.fromPeriod}-${query.toPeriod}.csv`
    a.click()
    URL.revokeObjectURL(url)
}

export const getConsultingRevenueVsBudget = (query: IConsultingRevenueVsBudgetQuery) => async (dispatch: Dispatch) => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/consulting-revenue-budget${buildQueryString(query)}`

        const res = await fetch(url, { credentials: 'include', method: 'GET' })

        if (!res.ok) {
            const errBody = await res.json()
            throw new Error(errBody.message)
        }

        const data = await res.json()
        dispatch(setData(data.data))
    } catch (err: any) {
        toast.error(err.message ?? "Error getting consulting revenue vs budget report")
    }
}
